
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.497 9.145h.003c.46 0 .832.372.833.831a8.277 8.277 0 01-2.424 5.9 8.28 8.28 0 01-5.885 2.458H10a8.277 8.277 0 01-5.876-2.425 8.279 8.279 0 01-2.457-5.885 8.275 8.275 0 012.424-5.9 8.279 8.279 0 015.885-2.457c.662.01 1.337.077 1.984.232a.834.834 0 01-.39 1.62 7.348 7.348 0 00-1.59-.185 6.622 6.622 0 00-4.708 1.965 6.623 6.623 0 00-1.939 4.72A6.623 6.623 0 005.3 14.729 6.624 6.624 0 0010 16.667h.02a6.622 6.622 0 004.707-1.966 6.624 6.624 0 001.94-4.72c-.001-.46.37-.835.83-.836zm-10.586.266a.832.832 0 011.178 0l1.87 1.87 5.248-5.997a.833.833 0 011.253 1.098l-5.833 6.667a.836.836 0 01-.6.285H10a.832.832 0 01-.59-.245l-2.5-2.5a.832.832 0 010-1.178z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.497 9.145h.003c.46 0 .832.372.833.831a8.277 8.277 0 01-2.424 5.9 8.28 8.28 0 01-5.885 2.458H10a8.277 8.277 0 01-5.876-2.425 8.279 8.279 0 01-2.457-5.885 8.275 8.275 0 012.424-5.9 8.279 8.279 0 015.885-2.457c.662.01 1.337.077 1.984.232a.834.834 0 01-.39 1.62 7.348 7.348 0 00-1.59-.185 6.622 6.622 0 00-4.708 1.965 6.623 6.623 0 00-1.939 4.72A6.623 6.623 0 005.3 14.729 6.624 6.624 0 0010 16.667h.02a6.622 6.622 0 004.707-1.966 6.624 6.624 0 001.94-4.72c-.001-.46.37-.835.83-.836zm-10.586.266a.832.832 0 011.178 0l1.87 1.87 5.248-5.997a.833.833 0 011.253 1.098l-5.833 6.667a.836.836 0 01-.6.285H10a.832.832 0 01-.59-.245l-2.5-2.5a.832.832 0 010-1.178z"}})])
          )
        }
      }
    